import { Component, Input } from '@angular/core';

import { UxService } from 'src/app/core/services/ux.service';
import { SignUpBaseComponent } from 'src/app/open-age/auth/components/join-base-component';
import { RoleService } from 'src/app/open-age/core/services';
import { environment } from '~/environments/environment';
import { ValidationService } from '../../../core/services/validation.service';
import { OrganizationService } from '../../../open-age/directory/services/organization.service';

@Component({
  selector: 'auth-signup',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css']
})
export class SignUpComponent extends SignUpBaseComponent {

  idTypes: string[] = [];

  hide = true;

  showPassword: false;
  constructor(
    auth: RoleService,
    organizationService: OrganizationService,
    validationService: ValidationService,
    uxService: UxService
  ) {
    super(auth, organizationService, validationService, uxService);

    this.idTypes = environment.loginTypes;
  }

  focusToNext(e: HTMLInputElement, nextEle?: HTMLInputElement) {
    if (e.value && nextEle && e.maxLength === e.value.length) {
      nextEle.select();
      nextEle.focus();
    }
  }

  labelFor(idType: string) {
    switch (idType) {
      case 'email':
        return 'Email';
      case 'mobile':
        return 'Mobile';
      case 'rollNo':
        return 'Roll No';
      case 'employeeNo':
        return 'Employee No';
    }
  }
}
